import React from 'react';
import { Box } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { PillTone } from './pillTone';

interface PillProps {
  tone?: PillTone;
  icon?: React.ReactNode;
  children: React.ReactNode;
  title?: string;
}

const TONE = {
  neutral: { bg: PRES.surfaceSunken, fg: PRES.textSecondary, border: PRES.borderSubtle },
  info: { bg: '#e8eef8', fg: PRES.interactive, border: '#c5d3ea' },
  warn: { bg: '#f7f1e4', fg: PRES.warn, border: '#ead9b3' },
  danger: { bg: '#f8e8e6', fg: PRES.danger, border: '#ebc8c4' },
} as const;

const Pill: React.FC<PillProps> = ({ tone = 'neutral', icon, children, title }) => {
  const colors = TONE[tone];
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.4,
        px: 0.75,
        py: 0.15,
        borderRadius: 99,
        bgcolor: colors.bg,
        color: colors.fg,
        border: `1px solid ${colors.border}`,
        fontFamily: TYPE.ui,
        ...TYPE.caption,
        whiteSpace: 'nowrap',
      }}
    >
      {icon}
      {children}
    </Box>
  );
};

export default Pill;
